import axios from 'axios';
import { ElMessageBox } from 'element-plus'
const instance = axios.create({
    // baseURL: 'http://10.10.20.85:702', // 测试
    // baseURL: 'http://172.16.82.21:702', // 生产
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 10000
});

// 请求拦截器
instance.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token')
    // 在发送请求之前做些什么
    if (token) {
        config.headers['Authorization'] = "Bearer " + token
    }
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(response => {
    // 对响应数据做点什么
    return response.data;
}, error => {
    if (error.response.status == '401') {
        // 认证超时
        ElMessageBox.alert(
            "登录状态已过期，请重新登录",
            "系统提示",
            {
              confirmButtonText: "重新登录",
            //   cancelButtonText: "取消",
              callback: (action) => {
                location.href = '/login'
              }
            }
          )
    } else {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
});

export default instance;